/** JUNTA DE ANDALUCIA **/

const AutoScript = window.AutoScript;


var BatchScript = {
	 VERSION : "1.0.2",
	 //raiz : "https://ws024.juntadeandalucia.es",
	 idsOriginal : [],
	 /*triphaseSignerContext : "afirma-server-triphase-signer-pru",
	 batchStorageService : "BatchStorageService",
	 batchRetrieveService : "BatchRetrieveService",*/
	 defaultSignAlgorithm : "SHA256withRSA",

	 triphaseUrls : {
		preSign: undefined,
		postSign: undefined,
	},

	
	//funciones genericas para los callbacks
	 callBackFunction : undefined,
	 errorCallbackFunction : undefined,
	 msgVersion : 1, //version de los mensajes

	//variables genericas para multimode y firma masiva
	 multimodeOperationArray : undefined,
	 multimodeDataArray : undefined,
	 multimodeOriginalDataArray : undefined,
	 multimodeArrayLength : undefined,
	 multimodeCommonSignAlgorithm : undefined,
	 multimodeCommonSignFormat : undefined,
	 multimodeCommonSignParams : undefined,
	 massiveResult : undefined,

	//var indice = 0;
	 massiveIndex : 1,
	 
	//solo para pruebas internas
	forceMobileMode : false
};

/**
 * Realiza una operacion de firma por lotes			 
 * @param stopOnError Indica si la firma del lote debería detenerse en el momento en el que se encuentre que una firma no es válida
 * @param commonAlgorithm Algoritmo de firma que se utilizará por defecto para todo el lote. Datos o firma en base 64.
 * @param commonFormat Formato de firma que se utilizará por defecto para todo el lote
 * @param commonSuboperation Operacion de firma (sign, cosign o countersing) a realizar por defecto para todo el lote
 * @param commonExtraparams Parametros por defecto para todo el lote
 * @param certFilters Filtros para los certificados
// * @param numDocuments
 * @param documentArray Array de datos a firmar. Los datos en base64
 * @param formatArray Array de formatos de firma a utilizar para cada dato. Si no se indica ninguno, se usará el que se indicó en commonFormat
 * @param suboperationArray Array de operaciones de firma a aplicar sobre cada dato. Si no se indica ninguna, se usará la que se indicó en commonSuboperation
 * @param extraparamArray Array de Parametros a aplicar sobre cada dato. Si no se indica ninguno, se usará el que se indico en commonExtraparams
 * @param showBatchFinalResultCallback Función JavaScript de retorno SIN errores (Opcional: showBatchFinalResultCallback(signatureB64, certificateB64)) 
 * @param showErrorCallback Función JavaScript de retorno CON errores (Opcional: showErrorCallback(errorType, errorMessage)) 
 */

function doSignBatch(
	stopOnError,
	commonAlgorithm,
	commonFormat,
	commonSuboperation,
	commonExtraparams,
	certFilters,
	//    numDocuments,
	documentArray,
	formatArray,
	suboperationArray,
	extraparamArray,
	showBatchFinalResultCallback,
	showErrorCallback) 
	{				
	
		try {
		/*BatchScript.triphaseUrls.preSign = BatchScript.raiz + "/" + BatchScript.triphaseSignerContext + "/presign";
			BatchScript.triphaseUrls.postSign = BatchScript.raiz + "/" + BatchScript.triphaseSignerContext + "/postsign";	

			AutoScript.setServlets(BatchScript.raiz	+ "/afirma-signature-storage-pru/StorageService",
			BatchScript.raiz+ "/afirma-signature-retriever-pru/RetrieveService");
				*/
			BatchScript.callBackFunction = showBatchFinalResultCallback;
			BatchScript.errorCallbackFunction = showErrorCallback;
			var numDocuments = 0;
			if (documentArray !=undefined)
			{
					numDocuments = documentArray.length;
			}
			//Si estamos en un entorno movil, firma por lotes
			if (AutoScript.isAndroid()||AutoScript.isIOS()||BatchScript.forceMobileMode)
			{
				checkMandatoryParams (commonAlgorithm,documentArray);
					
						
				//Creamos el lote
				AutoScript.createBatch(
					commonAlgorithm,
					commonFormat,
					commonSuboperation,
					commonExtraparams);
				//Añadimos los documentos/datos al lote
				for (let index = 0; index < documentArray.length; index++) {
			
					let id = generateUUID();
			
					let data = documentArray[index];
			
					BatchScript.idsOriginal.push(id);
					//Se almacena el documento/dato
					storageBatchSingleElement(id, BatchScript.msgVersion, data);
					//Se añade el documento/dato al lote
					//Se utiliza dos veces el ids porque no se necesita un id y un datareference distinto a la hora de almacenar
					let format = "";
					if (formatArray != null && formatArray != undefined && formatArray != "" ) {
						format = formatArray[index]
					}
					let extraparam = "";
					if (extraparamArray != null && extraparamArray != undefined && extraparamArray != "" ) {
						extraparam = extraparamArray[index];
					}
					let suboperation = "";
					if (suboperationArray != undefined && suboperationArray != [] && suboperationArray != null && suboperationArray != "")
					{
						suboperation = suboperationArray [index]
					}
					AutoScript.addDocumentToBatch(id, id,format, suboperation, extraparam);
					
				}

					AutoScript.setLocalBatchProcess(false);

					//Firmamos el lote
					AutoScript.signBatchProcess(
						stopOnError,
						BatchScript.triphaseUrls.preSign,
						BatchScript.triphaseUrls.postSign,
						certFilters,
						showBatchSecondaryResultCallback,
						showErrorCallback);
			}
			//Si estamos en un entorno de escritorio, firma recursiva
			else 
			{
				
				checkMandatoryParams (commonAlgorithm,documentArray);
				
				if (suboperationArray == undefined || suboperationArray == [] || suboperationArray == null || suboperationArray == "")
				{	
					suboperationArray = [0];
					for (let index = 0; index < documentArray.length; index++) 
					{
						suboperationArray [index] = commonSuboperation;
						
					}
				}
				
				
				BatchScript.multimodeOperationArray = suboperationArray;
				BatchScript.multimodeDataArray = documentArray;				
				BatchScript.multimodeArrayLength = documentArray.length;
				BatchScript.multimodeCommonSignAlgorithm = commonAlgorithm;
				BatchScript.multimodeCommonSignFormat = commonFormat;
				BatchScript.multimodeCommonSignParams = commonExtraparams;						
				doMassiveSign();
			}
		}
		catch (e) {
			multiModeErrorFunction(e.name, e.message, showErrorCallback);
		}
		
		
}


function showBatchSecondaryResultCallback(jsonBatch, certificateB64) {


	if (jsonBatch.hasOwnProperty("signs") && Array.isArray(jsonBatch.signs)) {
		var ids = jsonBatch.signs.map(function(item) {
			return item.id;
		});
		//let idsDesordenado = desordenarArray(ids);
		//let idsOrdenado = ordenarSegunOtroArray(BatchScript.idsOriginal, idsDesordenado)

		//batchRetrieve(ids,data => document.getElementById('result').value = "FIRMAS:\n" + JSON.stringify(data));
		//Ordenamos los ids porque signBatchProcess puede devolver los ids desordenados
		let sortedIds = ordenarSegunOtroArray(BatchScript.idsOriginal, ids);
		batchRetrieveSigns(sortedIds, function(resultado) {
			//Recorremos el JSON resultado y devolvemos sólo las firmas separadas por ':'
			var firmasB64 = "";
			var size = resultado.result.length;
			if (size) {
				for (let index = 0; index < size; index++) {
					if (index != (size - 1)) {
						firmasB64 += resultado.result[index].firma + ":";
					} else {
						firmasB64 += resultado.result[index].firma;
					}
				}
			}

			BatchScript.callBackFunction(firmasB64, certificateB64);
		});



	} else {
		console.error('La propiedad "signs" no existe en jsonBatch o no es un array');
	}

}


function storageBatchSingleElement(id, v, data) {
	var jsonRequest = {};
	jsonRequest.id = id;
	jsonRequest.v = v;
	jsonRequest.op = "put";
	jsonRequest.dat = data;

	let jsonData = JSON.stringify(jsonRequest);

	let xhr = new XMLHttpRequest();
	xhr.timeout = 5000;
	xhr.open(
		"POST",
		BatchScript.raiz + "/" + BatchScript.triphaseSignerContext + "/" + BatchScript.batchStorageService,
		true);

	//xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");

	xhr.onreadystatechange = function() {

		if (
			xhr.readyState === 4 &&
			xhr.status === 200 &&
			xhr.responseText != null) {
			console.log(xhr.responseText + " id: " + id);
			console.log("storageBatchSingleElement");
		}
	};


	try {
		
		xhr.onerror = function(e) {
			// status error 0 es que no se ha podido comunicar con la aplicacion
			if (e.target.status == 0) {
				if (BatchScript.callBackFunction) {
					BatchScript.callBackFunction("java.lang.IOException", "Se ha perdido la conexion con batchStorageService " + e.target.statusText);
				}
			}
			// error desconocido
			else {
				if (BatchScript.callBackFunction) {
					BatchScript.callBackFunction("java.lang.IOException", "Ocurrio un error de red en la llamada a batchStorageService " + e.target.statusText);
				}

			}
		}
	} catch (e) {
		multiModeErrorFunction(e.name, e.message);
	}

	xhr.ontimeout = function() {
		console.log("Timeout de conexión con storageBatchSingleElementService" + id);
		if (BatchScript.callBackFunction) {
			BatchScript.callBackFunction("java.lang.IOException", "Se ha cumplido el timeout de conexión con el servicio batchStorageService");
		}


	};
	xhr.send(jsonData);

}


function batchRetrieveSigns(identifiers, callback) {

	let jsonRetrieve = {};
	jsonRetrieve.ids = identifiers;
	jsonRetrieve.v = "1.0";
	jsonRetrieve.op = "get";

	let jsonData = JSON.stringify(jsonRetrieve);

	let xhr = new XMLHttpRequest();
	xhr.timeout = 5000;
	xhr.open(
		"POST",
		BatchScript.raiz + "/" + BatchScript.triphaseSignerContext + "/" + BatchScript.batchRetrieveService,
		true);
	//xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");

	xhr.onreadystatechange = function() {
		if (xhr.readyState === 4) {
			if (xhr.status === 200) {
				console.log("HTTP 200");
				console.log(xhr.responseText);
				console.log(JSON.parse(xhr.responseText));
				callback(JSON.parse(xhr.responseText));
			} else {

				return null;
			}
		}
	};

	try {
		
		xhr.onerror = function(e) {
			// status error 0 es que no se ha podido comunicar con la aplicacion
			if (e.target.status == 0) {
				if (BatchScript.callBackFunction) {
					BatchScript.callBackFunction("java.lang.IOException", "Se ha perdido la conexion con batchRetrieve " + e.target.statusText);
				}
			}
			// error desconocido
			else {
				if (BatchScript.callBackFunction) {
					BatchScript.callBackFunction("java.lang.IOException", "Ocurrio un error de red en la llamada a batchRetrieve " + e.target.statusText);
				}

			}
		}
	} catch (e) {
		multiModeErrorFunction(e.name, e.message, callback);
	}

	xhr.ontimeout = function() {
		console.log("Timeout de conexión con batchRetrieve");
		if (BatchScript.callBackFunction) {
			BatchScript.callBackFunction("java.lang.IOException", "Se ha cumplido el timeout de conexión con el servicio batchRetrieve");
		}


	};


	xhr.send(jsonData);

}



function ordenarSegunOtroArray(arrayOriginal, arrayDesordenado) {
	arrayDesordenado.sort((a, b) => {
		return arrayOriginal.indexOf(a) - arrayOriginal.indexOf(b);
	});

	return arrayDesordenado;
}

function desordenarArray(array) {
	var copy = array.slice(0);
	var currentIndex = copy.length,
		temporaryValue,
		randomIndex;
	while (0 !== currentIndex) {
		randomIndex = Math.floor(Math.random() * currentIndex);
		currentIndex -= 1;
		temporaryValue = copy[currentIndex];
		copy[currentIndex] = copy[randomIndex];
		copy[randomIndex] = temporaryValue;
	}
	return copy;
}

function generateUUID() {
	var d = new Date().getTime();
	if (window.performance && typeof window.performance.now === "function") {
		d += performance.now();; //use high-precision timer if available
	}
	var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g,
		function(c) {
			var r = (d + Math.random() * 16) % 16 | 0;
			d = Math.floor(d / 16);
			return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
		});
	return uuid;
}



/** Método centralizado para la firma simple y masiva **/
/** Parámetros: **/
/** operationArray: Define la operación a realizar ('sign, 'cosign' o 'countersign') **/
/** dataArray: Define los datos a firmar, pudiendo ser datos o hashes ('sign'), o firmas ('cosign' y 'countersign') **/
/** originalDataArray: Define los datos originales, solo útil para la operación 'cosign'. Es necesario rellenar con cadena vacía ("") en los casos de 'sign' y 'countersign' **/
/** arrayLength: Número entero que define el tamaño de las tablas, de forma que las tablas deben coincidir con este tamaño **/
/** commonSignAlgorithm: Algoritmo de firma común (Obligatorio:'SHA1withRSA', 'SHA256withRSA', 'SHA512withRSA') **/
/** commonSignFormat: Formato de firma común (Obligatorio: 'AUTO', 'CAdES', 'XAdES', 'PAdES', ...) **/
/** commonSignParams: Parámetros extra comunes para todas las operaciones, separados por '\n' (Opcional: 'precalculatedHashAlgorithm=SHA-128\n') **/
/** successCallback: Función JavaScript de retorno SIN errores (Opcional: successCallback(signatureB64, certificateB64)) **/
/** errorCallback: Función JavaScript de retorno CON errores (Opcional: errorCallback(type, message)) **/

AutoScript.multiModeSign = function(operationArray, dataArray, originalDataArray, arrayLength, commonSignAlgorithm, commonSignFormat, commonSignParams, successCallback, errorCallback) {

	console.log("Se utiliza el metodo multiModeSign");

	try {
						
			//Realizamos un matching de los parametros entre los metodos multimodeSign y doSignBatch
			var stopOnError = true; //Parametro del metodo signBatchProcess
			var commonAlgorithm = commonSignAlgorithm;    //Parametro del metodo createBatch
			var commonFormat = commonSignFormat; //Parametro del metodo createBatch
			//Se necesita un commonSuboperation y se cogerá la primera operación
			var commonSuboperation = operationArray[0]; //Parametro del metodo createBatch
			var commonExtraparams = commonSignParams; //Parametro del metodo createBatch
			var certFilters; //Parametro del metodo signBatchProcess
			var numDocuments = arrayLength;
			var documentArray = dataArray;
			var formatArray; //Parametro del metodo addDocumentToBatch
			var suboperationArray = operationArray; //Parametro del metodo addDocumentToBatch
			var extraparamArray; //Parametro del metodo addDocumentToBatch
			var showBatchFinalResultCallback = successCallback; //Parametro del metodo signBatchProcess
			var showErrorCallback = errorCallback;  //Parametro del metodo signBatchProcess
			
			doSignBatch(stopOnError, commonAlgorithm, commonFormat, commonSuboperation, commonExtraparams, certFilters,
			documentArray, formatArray, suboperationArray, extraparamArray, showBatchFinalResultCallback, showErrorCallback);

		
	} catch (e) {
		multiModeErrorFunction(e.name, e.message, errorCallback);
	}
}

var multiModeErrorFunction = function(type, message, errorCallback) {
	
		// Informar de error 
		if (errorCallback != undefined && errorCallback != null) {
			errorCallback(type, message);
		}
	
}



function doMassiveSign() {
	
	try {
		// Para firmar directamente un hash hay que pasar un el parámetro extra correspondiente:
		// Por ejemplo: precalculatedHashAlgorithm=SHA-256				

		//indice = 0;
		BatchScript.massiveIndex = 0;	
		//fijamos el certificado con el que se va a firmar
		AutoScript.setStickySignatory(true);

		signMassive();

	} catch (e) {
		try {
			console.log("Type: " + AutoScript.getErrorType() + "\nMessage: " + AutoScript.getErrorMessage());
		} catch (ex) {
			console.log("Error: " + e);
		}
	}
}		
		
		
function signMassive(signatureB64, certificateB64) {
	if (signatureB64 != undefined) {
		BatchScript.massiveIndex++;
		console.log("Firma masiva [" + BatchScript.massiveIndex + "] OK");
	
		if (BatchScript.massiveIndex ==1) {
			BatchScript.massiveResult = signatureB64;
		} else {
			BatchScript.massiveResult += ":" + signatureB64;
		}
	}
	
	if (BatchScript.multimodeDataArray[BatchScript.massiveIndex] != undefined) {
		if(BatchScript.multimodeOperationArray[BatchScript.massiveIndex] == "sign") {
			AutoScript.sign(BatchScript.multimodeDataArray[BatchScript.massiveIndex], BatchScript.multimodeCommonSignAlgorithm, BatchScript.multimodeCommonSignFormat, BatchScript.multimodeCommonSignParams, signMassive, BatchScript.errorCallbackFunction);
		} else if(BatchScript.multimodeOperationArray[BatchScript.massiveIndex] == "cosign") {
			AutoScript.coSign(BatchScript.multimodeDataArray[BatchScript.massiveIndex],"", BatchScript.multimodeCommonSignAlgorithm, BatchScript.multimodeCommonSignFormat, BatchScript.multimodeCommonSignParams, signMassive, BatchScript.errorCallbackFunction);
		} else if(BatchScript.multimodeOperationArray[BatchScript.massiveIndex] == "countersign") {
			AutoScript.counterSign(BatchScript.multimodeDataArray[BatchScript.massiveIndex], BatchScript.multimodeCommonSignAlgorithm, BatchScript.multimodeCommonSignFormat, BatchScript.multimodeCommonSignParams, signMassive, BatchScript.errorCallbackFunction);
		} else {
			BatchScript.errorCallbackFunction ("UndefinedSignOperation","No se ha especificado ninguna operacion de firma (sign, cosign o countersign)");
		}
	}
	else {
		BatchScript.massiveIndex = 0;
		AutoScript.setStickySignatory(false);
		BatchScript.callBackFunction(BatchScript.massiveResult,certificateB64)
	}	
}

function checkMandatoryParams (commonAlgorithm,documentArray)
{
	if (commonAlgorithm == null || commonAlgorithm == undefined || commonAlgorithm == "" ) {
			commonAlgorithm =	BatchScript.defaultSignAlgorithm;
			throw new TypeError("Definición incorrecta de los parámetros de entrada, commonAlgorithm no puede ser nulos");
		}
		if(	documentArray == null || documentArray == undefined || documentArray == [] ) {
			throw new TypeError("Definición incorrecta de los parámetros de entrada, documentArray no puede ser nulo o vacio");
		}
}

if (typeof window !== 'undefined') {
  window.BatchScript = BatchScript;
  window.doSignBatch = doSignBatch;
}